import { render } from "./CelebrationConfettiRain.vue?vue&type=template&id=5529e5b9&scoped=true"
import script from "./CelebrationConfettiRain.vue?vue&type=script&lang=js"
export * from "./CelebrationConfettiRain.vue?vue&type=script&lang=js"

import "./CelebrationConfettiRain.vue?vue&type=style&index=0&id=5529e5b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5529e5b9"]])

export default __exports__